{
  "close": "Sluiten",
  "notifications": "Meldingen"
}
